import { COLORS as COLORS_OLD } from '@r1-frontend/ui-react/assets/js/constants';
import { AccordionAnimate } from '@r1-frontend/ui-react/components/accordions/AccordionAnimate';
import { AccordionAnimateBody } from '@r1-frontend/ui-react/components/accordions/AccordionAnimate/AccordionAnimateBody';
import { AccordionAnimateHeader } from '@r1-frontend/ui-react/components/accordions/AccordionAnimate/AccordionAnimateHeader';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';
import React, { Component } from 'react';
import styled, { css } from 'styled-components';

import { EGP_IMG } from '~/src/constants';

import { dateToScheduleFormat } from '../helpers';

const FutureBroadcasts = styled.div`
    margin-top: 16px;
    width: 100%;
`;

const BroadcastTime = styled.div`
    flex-shrink: 0;
    text-align: center;
    width: 66px;
`;

const BroadcastTitle = styled.div`
    flex-grow: 1;
`;

const Broadcast = styled.div`
    align-items: stretch;
    color: ${COLORS_OLD.darkGrey};
    cursor: pointer;
    display: flex;
    flex-direction: column;
    ${FONTS.S};
    margin-top: 16px;
    outline: none;
    position: relative;
    width: 88%;

    @media only screen and (max-width: 1359px) {
        width: 100%;
    }

    &:first-child {
        margin-top: 0;
    }

    ${({ broadcastStatus }) => broadcastStatus && css`
        ${BroadcastTime},
        ${BroadcastTitle} {
            color: ${COLORS.TextPrimary};
        }
    `}

    ${({ broadcastStatus }) => broadcastStatus === null && css`
        ${BroadcastTitle} {
            color: ${COLORS.TextPrimary};
        }
    `}

    &:focus,
    &:active {
        ${css`
            ${BroadcastTime},
            ${BroadcastTitle} {
                color: ${COLORS_OLD.red};
            }
        `}
    }
`;

const BroadcastProgress = styled.div`
    background-color: ${COLORS_OLD.grey};
    display: block;
    height: 3px;
    margin-top: 6px;
    width: 100%;
`;

const BroadcastProgressBar = styled.div`
    background-color: ${COLORS_OLD.lightGreen};
    display: block;
    height: 100%;
    width: 0;
`;

const BroadcastHead = styled.div`
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
`;

const BroadcastContent = styled.div`
    width: 100%;
    display: flex;
    flex-flow: row;
    margin-top: 10px;

    span {
        max-width: 55%;
    }
`;

const BroadcastContentPicture = styled.div`
    width: 100%;
    max-height: 112px;
    max-width: 198px;
    overflow: hidden;
    margin-right: 20px;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`;

export default class ChannelDetail extends Component {
    constructor(props) {
        super(props);

        this.state = {
            accordionIsShow: false,
        };
    }

    onBroadcastClick = (event, broadcast, index) => {
        if (index > 4) {
            const content = {
                title: broadcast.title,
                desc: broadcast.desc,
                icon: broadcast.icon,
            };

            const coordinates = {
                x: event.clientX,
                y: event.clientY,
            };

            this.props.tooltipOpen(content, coordinates);
        } else {
            return;
        }
    }

    render() {
        const pastBroadcasts = this.props.pastBroadcasts.map((broadcast, index) => (
            <Broadcast
                broadcastStatus={broadcast.status}
                key={broadcast.title + index}
                onClick={(event) => this.onBroadcastClick(event, broadcast) }
                tabIndex='0'
            >
                {/* <BroadcastTime>{dateToScheduleFormat(broadcast.start)}</BroadcastTime> */}
                <BroadcastTitle>{broadcast.title}</BroadcastTitle>
            </Broadcast>
        ));

        const futureBroadcasts = this.props.futureBroadcasts.map((broadcast, index) => {
            let progress = null;

            if (broadcast.status === true) {
                progress = (
                    <BroadcastProgress>
                        <BroadcastProgressBar style={{ width: `${broadcast.progress}%` }}></BroadcastProgressBar>
                    </BroadcastProgress>
                );
            }

            return (
                <Broadcast
                    broadcastStatus={broadcast.status}
                    key={broadcast.title + index}
                    onClick={(event) => this.onBroadcastClick(event, broadcast, index)}
                    tabIndex='0'
                >
                    <BroadcastHead>
                        <BroadcastTime>{dateToScheduleFormat(new Date(broadcast.start))}</BroadcastTime>
                        <BroadcastTitle>
                            {broadcast.title}
                            {progress}
                        </BroadcastTitle>
                    </BroadcastHead>
                    {index <= 4 && <BroadcastContent>
                        {broadcast.icon && <BroadcastContentPicture>
                            <img src={`${EGP_IMG}${broadcast.icon}`} alt={broadcast.title} />
                        </BroadcastContentPicture>}
                        {broadcast.desc && <span>{broadcast.desc}</span>}
                    </BroadcastContent>
                    }
                </Broadcast>
            );
        });

        const settings = {
            margin: 0,
            text: 'Показать прошедшие передачи',
        };

        if (this.state.accordionIsShow) {
            settings.margin = '40px';
            settings.text = 'Cкрыть прошедшие передачи';
        }

        let template = (<div>Расписания нет</div>);

        if (this.props.pastBroadcasts.length > 0 && this.props.futureBroadcasts.length > 0) {
            template = (
                <AccordionAnimate onToggle={status => {
                    this.setState({ accordionIsShow: status });
                }}>
                    <AccordionAnimateBody>{pastBroadcasts}</AccordionAnimateBody>
                    <AccordionAnimateHeader style={{ marginTop: settings.margin }} text={settings.text} />
                    <FutureBroadcasts>
                        {futureBroadcasts}
                    </FutureBroadcasts>
                </AccordionAnimate>
            );
        } else if (this.props.pastBroadcasts.length > 0) {
            template = pastBroadcasts;
        } else if (this.props.futureBroadcasts.length > 0) {
            template = futureBroadcasts;
        }

        return template;
    }
}
